import React, { useEffect, useState } from 'react';
import { adminHomeSettingService } from '../services';
import { resolveMediaUrl } from '../services/api';
import { notifyError, notifySuccess } from '../utils/toast';

const HomeSettings = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [setting, setSetting] = useState(null);
    const [videoFile, setVideoFile] = useState(null);

    useEffect(() => {
        fetchSetting();
    }, []);

    const fetchSetting = async () => {
        try {
            const response = await adminHomeSettingService.get();
            setSetting(response.data || null);
        } catch (error) {
            notifyError('Unable to load home settings.');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!videoFile) {
            notifyError('Please select a video file.');
            return;
        }
        setSaving(true);
        try {
            await adminHomeSettingService.update({ video_file: videoFile });
            notifySuccess('Home video updated successfully.');
            setVideoFile(null);
            await fetchSetting();
        } catch (error) {
            notifyError(error.response?.data?.message || 'Unable to save home settings.');
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <div className="py-12 text-center">
                <div className="inline-block h-12 w-12 animate-spin rounded-full border-b-2 border-emerald-600"></div>
            </div>
        );
    }

    return (
        <div>
            <h1 className="mb-8 text-4xl font-bold text-gray-800">Home Settings</h1>
            <div className="rounded-lg bg-white p-8 shadow-lg">
                <h2 className="mb-6 text-2xl font-bold text-gray-800">Home Video Upload</h2>
                <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-6">
                    <div>
                        <label className="mb-2 block font-semibold text-gray-700">Upload Video (mp4/webm/ogg)</label>
                        <input
                            type="file"
                            accept="video/mp4,video/webm,video/ogg"
                            onChange={(e) => setVideoFile(e.target.files?.[0] || null)}
                            className="w-full rounded-lg border border-gray-300 px-4 py-2"
                        />
                    </div>
                    {setting?.video_path && (
                        <div>
                            <p className="mb-2 text-sm font-semibold text-gray-700">Current Video Preview</p>
                            <video src={resolveMediaUrl(setting.video_path)} controls className="max-h-72 w-full rounded-lg border border-gray-200" />
                        </div>
                    )}
                    <button
                        type="submit"
                        disabled={saving}
                        className="rounded-lg bg-emerald-600 px-6 py-2 font-semibold text-white hover:bg-emerald-700 disabled:opacity-50"
                    >
                        {saving ? 'Saving...' : 'Save Home Video'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default HomeSettings;
